import useConfiguration from "system/hooks/use-configuration";
import GlobalAdminPackagesView from "./GlobalAdminPackagesView";
import TenantPackagesView from "./TenantPackagesView";

const PackagesPage = () => {
  const { currentTenant, isGlobalAdmin } = useConfiguration();

  if (isGlobalAdmin) {
    return <GlobalAdminPackagesView />;
  }
  if (!currentTenant?.shortName) {
    return null;
  }
  return <TenantPackagesView shortName={currentTenant.shortName} />;
};

export default PackagesPage;
